<template>
	<!-- 幸运礼包iaa广告版 -->
	<div class="luckysdkBox" @click="closeEmp">
		<div class="luckyBox" v-if="!initLoading">
			<div class="closeBtn" :class="{'lans':(!isios && osType == 2) || (isios && osType == 1)}" @click="closePage" v-if="!isGameIdInList(infosGame, GAME_IDS.NO_TIPS) && !isGameIdInList(infosGame, ['2335'])"></div>
			<img class="bg" ref="bgRef" :class="{'lans':(!isios && osType == 2) || (isios && osType == 1)}" :src="imgbg" @load="setBtnPos" @click.stop="handleEmp" />
			<div class="btn" :style="btnStyle" :class="{'lans':(!isios && osType == 2) || (isios && osType == 1)}" @click.stop="handleView">
				<img :src="imgbtn" />
			</div>
			<div class="tipsBox" :class="{'lans':(!isios && osType == 2) || (isios && osType == 1)}" v-if="!isGameIdInList(infosGame, GAME_IDS.NO_TIPS)">
				<div class="closeTips" @click.stop="closePage" v-if="!isGameIdInList(infosGame, ['2335'])">
					点空白处关闭<span v-if="timerNum >= 0">({{ timerNum }}S)</span>
				</div>
				<div class="closeTips" v-if="timeCounts > 0">
					<el-countdown title="" :value="timeCount" format="福利倒计时：HH 时 mm 分 ss 秒" />
					<!-- <van-count-down :time="timeCounts" format="福利倒计时：HH 时 mm 分 ss 秒" /> -->
				</div>
			</div>
			
		</div>
		<div class="luckyBox" v-else>
			<div class="bg loading"><el-icon :size="20"><Loading /></el-icon></div>
		</div>
	</div>
</template>

<script setup>
	import { getCurrentInstance,onMounted,onBeforeMount,ref,watch,computed, onUnmounted } from 'vue'
	import { useRouter } from 'vue-router'
	// import useUserStore from '@/store/modules/user'
	// import useGiftStore from '@/store/modules/gift'
	import useIaaStore from '@/store/modules/iaaParams'
	// import CryptoJS from "crypto-js"
	// import { getLuckyGiftURL, getLuckyGiftAds } from '@/api/index.js'
	// import { gmrewardsPack } from '@/api/ads.js'
	import iaaSdk from '@/utils/iaa_sdk'
	
	import { getSignStr, getRandomNum } from '@/utils/common'
	
	const { proxy } = getCurrentInstance();
	const router = useRouter();
	const secretParams = computed(() => {
		return useIaaStore().secretParams
	})
	const osType = computed(() => {
		return useIaaStore().ostype
	})
	const isios = computed(() => {
		const u = navigator.userAgent;
		return !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
	})
	const isAdsLucky = computed(() => {
		return useIaaStore().isAdLucky
	})
	const isRefresh = computed(() => {
		return useIaaStore().isRefresh
	})
	const isAdSuccess = computed(() => {
		return useIaaStore().isAdSuccess
	})
	const imgbg = ref('')
	const imgbtn = ref('')
	const bgRef = ref(null)
	const btnStyle = ref(null)
	// 2496:老WebView对百分比定位解析不可靠,JS量底图实际位置,把按钮定到底图70%高度处(横幅正下方)
	const setBtnPos = () => {
		if(!isGameIdInList(infosGame.value, ['2496'])){
			return
		}
		let img = bgRef.value
		if(!img || !img.parentElement){
			return
		}
		let r = img.getBoundingClientRect()
		let p = img.parentElement.getBoundingClientRect()
		if(!r.width){
			return
		}
		btnStyle.value = {
			left: Math.round(r.left - p.left + r.width / 2) + 'px',
			top: Math.round(r.top - p.top + r.height * 0.7) + 'px',
			width: Math.round(r.width * 0.41) + 'px',
			transform: 'translateX(-50%)'
		}
	}
	const isweb = ref(0)
	// const key = ref('a09ec3eb33f204b2ae7b511e760877cc')
	const timeCount = ref(Date.now())
	const timeCounts = ref(0)
	const itimer = ref(null)
	const timer = ref(null)
	const timerInit = ref(2)
	const timerNum = ref(0)
	const initTimerNum = ref(0)
	const initLoading = ref(true)
	const adLoading = ref(false)
	const closeLoading = ref(false)
	const isSpecial = ref(0)
	const queryParams = ref({})
	const infosGame = ref('')

	// 游戏ID配置
	const GAME_IDS = {
		SPECIAL_LUCKY: ['2307', '2272', '2399', '2356', '2415', '2343', '2421','2450','2496'], // 免广告领取游戏ID
		NO_TIPS: ['2272', '2399', '2356', '2415', '2343', '2421', '2450','2496'], // 不显示提示框游戏ID
		NO_CLOSE_EMPTY: ['2272', '2335', '2399', '2356', '2415', '2343', '2421','2450','2496'] // 不能点空白处关闭游戏ID
	}

	// 判断游戏ID是否在指定列表中
	const isGameIdInList = (gameId, list) => {
		return list.includes(gameId)
	}
	onMounted(() => {
		queryParams.value = router.currentRoute.value.query;
		if(queryParams.value && queryParams.value.isTest){
			useIaaStore().setIsTest(queryParams.value.isTest)
		}else{
			useIaaStore().setIsTest(0)
		}
		if(queryParams.value.isweb){
			isweb.value = queryParams.value.isweb || 0
			useIaaStore().setIsweb(isweb.value)
		}
		if(queryParams.value.ostype){
			useIaaStore().setOstype(queryParams.value.ostype)
		}
		if(secretParams.value){
			console.log('有加密串直接请求接口====')
			init()
		}else{
			console.log('页面加载====')
			iaaSdk.sdkPostMsg({ action: 'webDidLoad' })
		}
		// if(process.env.NODE_ENV === 'development'){
		// }
		window.addEventListener('resize', setBtnPos)
	})
	onUnmounted(() => {
		clearTimer()
		clearInitTimer()
		window.removeEventListener('resize', setBtnPos)
	})
	// 两秒后才能点关闭按钮
	const closeTimer = () => {
		timerNum.value = timerInit.value
		closeLoading.value = true
		timer.value = setInterval(() => {
			timerNum.value --
			if(timerNum.value < 0){
				closeLoading.value = false
				clearTimer()
			}
		},1000)
	}
	const clearTimer = () => {
		clearInterval(timer.value)
		timer.value = null
	}
	const clearInitTimer = () => {
		clearInterval(itimer.value)
		itimer.value = null
	}
	// 处理幸运礼包逻辑（统一方法）
	const handleLuckyGift = () => {
		let infos = iaaSdk.sdkGetInfos() || {}
		iaaSdk.sdkGmDialogRewardInfo((data) => {
			if((data && data.luckyIaa == 1) || isGameIdInList(infos.gameId, GAME_IDS.SPECIAL_LUCKY)){
				// 走幸运礼包逻辑
				initLoading.value = false
				closeTimer()
				getGift()
			}else{
				console.log('跳转iaa===')
				goIaa()
			}
		},(err) => {
			console.log('获取幸运礼包信息失败:', err)
		})
	}

	const init = () => {
		let infos = iaaSdk.sdkGetInfos() || {}
		infosGame.value = infos.gameId
		// 2496:统一走 /iaasdk 专属图,不显示本页接口图,也不走 goIaa
		if(infosGame.value == '2496'){
			router.replace({ name: 'Iaasdk', query: queryParams.value })
			return
		}
		initLoading.value = true

		// 先判断是否接入IAA
		iaaSdk.sdkIaaGame(infosGame.value,(res) => {
			const iaaGame = res.iaaGame // 0是不接入，1是接入
			console.log('是否接入IAA:', iaaGame)

			if (iaaGame == 0) {
				// 不接入IAA，直接走成功逻辑
				initLoading.value = false
				closeTimer()
				getGift()
			} else {
				// 接入IAA，走接口判断逻辑
				handleLuckyGift()
			}
		},(err) => {
			console.log('判断IAA接入失败:', err)
			// 判断失败时，直接关闭页面
			close()
		})
	}
	const goIaa = () => {
		initLoading.value = false;
		router.push({ name: 'Gmiaa', query: queryParams.value });
	}
	const getSpecial = () => {
		iaaSdk.sdkGmSpecialState((res) => {
			isSpecial.value = res.data.specialStatus || 0//1免广告版0正常
		},(err) => {
			console.log(err)
		})
	}
	const getGift = () => {
		let infos = iaaSdk.sdkGetInfos() || {}
		// if(infos && infos.gameId){
		// 	console.log(infos.gameId)
		// 	if(infos.gameId == '2266' && infos.chanleNo != '40048'){//2266
		// 		isSpecial.value = true
		// 	}else{
		// 		isSpecial.value = false
		// 	}
		// }
		getSpecial()
		// let data = '[{"resourcePath":"https://qpyx-rlsb.oss-cn-shanghai.aliyuncs.com/2023/12/05/7070309d80c34eedaedebea386dfbfdf.png","resourceName":"img_btn2"}, {"resourcePath":"https://qpyx-rlsb.oss-cn-shanghai.aliyuncs.com/2023/12/05/68738d1fc1c54fd6b14ae89d05e17b10.png","resourceName":"img_btn3"}, {"resourcePath":"https://qpyx-rlsb.oss-cn-shanghai.aliyuncs.com/2023/12/05/58d680944902475a853466f07ebdd38a.png","resourceName":"img_luck2"}, {"resourcePath":"https://qpyx-rlsb.oss-cn-shanghai.aliyuncs.com/2023/12/05/11756faf1cce4860b70f3f2e108a4320.png","resourceName":"img_btn"}, {"resourcePath":"https://qpyx-rlsb.oss-cn-shanghai.aliyuncs.com/2023/12/05/a4d0337fb0764c358fbea77ef9a36c98.png","resourceName":"img_luck3"}, {"resourcePath":"https://qpyx-rlsb.oss-cn-shanghai.aliyuncs.com/2023/12/05/5251175de40c4171922446184bd397ab.png","resourceName":"img_luck"}]'
		// let obj = JSON.parse(data)
		iaaSdk.sdkGmLuckyGift((res) => {
			if(res.data){
				let obj = JSON.parse(res.data)
				let btnKey = 'img_btn',imgKey = 'img_luck';
				if(Number(res.msg) > 0){
					timeCounts.value = Number(res.msg) * 1000;
					timeCount.value = Date.now() + Number(res.msg) * 1000;
					initTimerNum.value = Number(res.msg);
					initTimer()
				}
				obj.forEach((item) => {
					if(item.resourceName == btnKey){
						imgbtn.value = item.resourcePath
					}else if(item.resourceName == imgKey){
						imgbg.value = item.resourcePath
					}
				})
			}else{
				console.log('接口返回异常=====')
				// proxy.commonPostMsg({ action: 'back_action' })
			}
		},(err) => {
			console.log(err)
		})
	}
	const initTimer = () => {
		itimer.value = setInterval(() => {
			initTimerNum.value --
			let min = Math.floor(initTimerNum.value / 60)
			let s = initTimerNum.value - min * 60
			if(initTimerNum.value < 0){
				clearInitTimer()
				console.log('倒计时结束跳转iaa===')
				goIaa()
			}
			console.log(`${min}分：${s}秒`)
		},1000)
	}
	const handleEmp = () => {
		console.log('点击图片=====')
	}
	const handleView = () => {
		if(adLoading.value){
			console.log('重复点击===')
			return false
		}
		adLoading.value = true
		let infos = iaaSdk.sdkGetInfos() || {}
		console.log(infos)
		if(isSpecial.value == 1 || isGameIdInList(infos.gameId, GAME_IDS.SPECIAL_LUCKY)){
			iaaSdk.sdkGmLuckyGiftSpecial((data) => {
				adLoading.value = false
				let msg = data.msg || '领取成功'
				if(isGameIdInList(infos.gameId, ['2496'])){
					// 2496:提示放屏幕中部放大醒目(老WebView用JS算px);延迟关闭,否则close后toast随页面销毁
					proxy.$toast({ message: '领取成功，前往邮件领取', type: 'success', customClass: 'toast2496', offset: Math.round(window.innerHeight * 0.42) })
					setTimeout(() => { clear() }, 1000)
				}else{
					proxy.$toast({ message: msg, type: 'success' })
					clear()
				}
			},(err) => {
				adLoading.value = false
				clear()
				console.log(err)
			})
		}else{
			console.log('领取去看广告====')
			iaaSdk.sdkGmLuckyGiftOrder((res) => {
				adLoading.value = false
				iaaSdk.sdkPostMsg({ action: 'playAdsLucky', data: res.data })
			},(err) => {
				adLoading.value = false
				clear()
				console.log(err)
			})
		}
	}
	const closeEmp = () => {
		if(isGameIdInList(infosGame.value, GAME_IDS.NO_CLOSE_EMPTY)){
			console.log('该游戏点空白处不能关闭')
		}else{
			closePage()
		}
	}
	const closePage = () => {
		if(!timer.value){
			clear()
			// proxy.commonPostMsg({ action: 'close' },'ads')
		}else{
			console.log(`${timerInit.value}s内不能关闭`)
		}
	}
	// const getSignStr = (params) => {
	// 	let str = '',sign = '';
	// 	for(let i in params){
	// 		str += params[i]
	// 	}
	// 	str += key.value
	// 	sign = CryptoJS.MD5(str).toString()
	// 	return sign
	// }
	// const getRandomNum = () => {
	// 	let date = new Date()
	// 	let time = date.getTime()
	// 	let num = Math.ceil(Math.random()*1000)
	// 	return time + '_' + num
	// }
	const clear = () => {
		initLoading.value = true
		imgbg.value = ''
		imgbtn.value = ''
		useIaaStore().setSecretParams('').then(() => {
			iaaSdk.sdkPostMsg({ action: 'close' })
		})
	}
	watch(secretParams, (newVal,oldVal) => {
		console.log('监听到数据=====初始化')
		if(newVal){
			init()
		}
	},{ deep:true })
	watch(isAdsLucky, (newVal,oldVal) => {
		if(newVal == 1){
			useGiftStore().setAdLucky(0).then(() => {
				console.log('显示loading,图片链接置空===')
				clear()
			})
		}
	},{ deep:true, immediate: true })
	watch(isRefresh, (newVal,oldVal) => {
		useIaaStore().setRefresh('')
	},{ deep:true })
	watch(isAdSuccess, (newVal,oldVal) => {
		useIaaStore().setAdSuccess(0)
	},{ deep:true })
</script>

<style lang="less" scoped>
	.luckysdkBox{
		width: 100%;height: 100vh;
		.luckyBox{
			width: 100%;height: 100vh;position: relative;max-width: 39rem;margin: 0 auto;
			.bg{
				width: 100%;max-width: 32rem;
				position: absolute;top: 50%;left: 50%;transform: translate(-50%,-50%);
				&.loading{
					text-align: center;min-height: 5rem;
				}
				&.lans{
					max-width: 100%;
				}
			}
			.closeBtn{
				position: absolute;top: 50%;left: 50%;transform: translate(-50%,-50%);
				width: 3rem;height: 3rem;z-index: 111;text-align: right;font-size: 1.2rem;
				background: url('/iaa/close_icon.png') no-repeat center;
				background-size: 100%;
				margin-top: -22%;
				margin-left: calc(50% - 3rem);
				&.lans{
					margin-top: -28%;
					margin-left: 50%;
				}
			}
			.tipsBox{
				position: absolute;top: 68%;left: 50%;transform: translate(-50%,-50%);
				width: 100%;
				&.lans{
					top: 88%;
				}
			}
			.closeTips{
				background: linear-gradient(to right,transparent,#000,transparent);color: #fff;text-align: center;
				font-size: 1.4rem;margin-top: 0.5rem;
				/deep/.el-statistic__content{
					display: contents;
				}
				/deep/.el-statistic__number{
					color: #fff;font-size: 1.4rem;
				}
			}
			.btn{
				position: absolute;top: 63%;left: 50%;transform: translate(-50%,-50%);
				width: 12rem;
				img{
					width: 100%;
				}
				&.lans{
					top: 78%;width: 12rem;
				}
			}
			.adsBtn{
				background: red;color: #fff;text-align: center;
			}
		}
	}
</style>

<style>
	/* 2496领取提示:居中黑底白字(ElMessage挂在body上,须全局样式;此块只能写纯CSS) */
	.el-message.toast2496{
		background: rgba(0,0,0,0.8);
		border: none;
		border-radius: 6px;
		padding: 12px 24px;
	}
	.el-message.toast2496 .el-message__icon,
	.el-message.toast2496 .el-icon,
	.el-message.toast2496 .el-message-icon--success{
		display: none;
	}
	.el-message.toast2496 .el-message__content{
		color: #fff;
		font-size: 16px;
	}
</style>